/** When the team last ran over this site, beside Rerun all agents: the daily pass or
 * someone's rerun. Comment reviews and conversations are not runs over the site.
 */
import { Link } from "react-router-dom";

import { useLastScheduledRun } from "../api/hooks/useStatefulAgents";
import { projectScheduledPath } from "../routes/learningAgentPaths";
import { formatWhen } from "../utils/formatWhen";
import styles from "./LastRun.module.css";

export const LastRun = ({ projectId }: { projectId: string }) => {
  const { data, error } = useLastScheduledRun(projectId);
  if (error) return <span className={styles.error}>Could not load the last run.</span>;
  if (!data) return null;
  const last = data.run;
  if (!last) return <span className={styles.lastRun}>No run yet.</span>;
  return (
    <Link className={styles.lastRun} to={projectScheduledPath(projectId, last.run_id)}>
      {last.running ? "Running since" : "Last run"} {formatWhen(last.created_at)}
    </Link>
  );
};
